/* Roasterland passport helpers. Reads the JSON from snippets/passport-data.liquid and merges
   stamps from orders/account, coffees tasted in this browser (RLProfile) and manual stamps. */
(function () {
  'use strict';
  var KEY = 'rl_passport_manual_v1';
  function data() {
    var el = document.querySelector('[data-pp-data]');
    if (!el) return null;
    if (!el.__d) el.__d = JSON.parse(el.textContent);
    return el.__d;
  }
  function manual() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  var P = {
    data: data,
    manual: manual,
    saveManual: function (m) { try { localStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {} },
    // handle -> { d, src: order | saved | browser | manual }
    stamps: function () {
      var D = data(); if (!D) return {};
      var byH = {}, byName = {}, s = {};
      D.origins.forEach(function (o) { byH[o.h] = o; byName[o.n.toLowerCase()] = o.h; });
      (D.stamps || '').split(';').forEach(function (kv) {
        if (!kv) return; var p = kv.split('='); if (!byH[p[0]]) return;
        if (!s[p[0]] || (p[1] && (!s[p[0]].d || p[1] < s[p[0]].d))) s[p[0]] = { d: p[1] || '', src: p[1] ? 'order' : 'saved' };
      });
      var prof = window.RLProfile && window.RLProfile.get();
      if (prof && prof.tasted) Object.keys(prof.tasted).forEach(function (n) {
        var h = byName[n.toLowerCase()]; if (h && !s[h]) s[h] = { d: new Date(prof.tasted[n]).toISOString().slice(0, 10), src: 'browser' };
      });
      var m = manual(); Object.keys(m).forEach(function (h) { if (byH[h] && !s[h]) s[h] = { d: m[h], src: 'manual' }; });
      return s;
    },
    // The origins a club track would send next, in order. track: 'Explorer' | 'Gold Run'
    queue: function (track) {
      var D = data(); if (!D) return [];
      var S = P.stamps();
      var list = D.origins.filter(function (o) { return !S[o.h] && o.p && o.p.length && (track !== 'Gold Run' || o.t === 'Rare'); });
      // Explorer opens with a classic so the first box is a crowd-pleaser, then alternates
      if (track !== 'Gold Run') {
        var cl = list.filter(function (o) { return o.t !== 'Rare'; }), ra = list.filter(function (o) { return o.t === 'Rare'; }), out = [];
        while (cl.length || ra.length) { if (cl.length) out.push(cl.shift()); if (ra.length) out.push(ra.shift()); }
        return out;
      }
      return list;
    }
  };
  window.RLPassport = P;
})();
